export const setUsersPermissions = (permissions, userPermissions) => {
  if (!userPermissions?.length) return [];

  return permissions?.filter(permission => userPermissions.find(item => item === permission?.id));
}
